<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="visible"
    [style]="{ width: '330px' }" (onHide)="handleHide()">
    <div class="text-center fm-prompt">
        <div class="text-black mb-1" style="font-size: 1.2rem; font-weight: 500;">
            Sign up
        </div>
        <div class="fm-rubik mb-2" style="font-size: 0.85rem;font-weight: 400;">
            Log In To Your Account To Continue
        </div>
        <div class="mt-1 p-1 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.75rem;color: #848790;font-weight: 500;">Name</span>
            <input type="text" class="p-2 w-100 input-promo" style="font-size: 0.85rem;font-weight: bold;"
                placeholder="Name" [(ngModel)]="signupModel.first_name" />
        </div>
        <div class="mt-1 p-1 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.75rem;color: #848790;font-weight: 500;">Last name</span>
            <input type="text" class="p-2 w-100 input-promo" style="font-size: 0.85rem;font-weight: bold;"
                placeholder="Last name" [(ngModel)]="signupModel.last_name" />
        </div>
        <div class="mt-1 p-1 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.75rem;color: #848790;font-weight: 500;">Phone number</span>
            <input type="text" class="p-2 w-100 input-promo" style="font-size: 0.85rem;font-weight: bold;"
                placeholder="Phone number" [(ngModel)]="signupModel.phone_number" />
        </div>
        <div class="mt-1 p-1 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.75rem;color: #848790;font-weight: 500;">Email</span>
            <input type="email" class="p-2 w-100 input-promo" style="font-size: 0.85rem;font-weight: bold;"
                placeholder="Name@example.com" [(ngModel)]="signupModel.email" />
        </div>
        <div class="mt-1 p-1 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.75rem;color: #848790;font-weight: 500;">Password</span>
            <p-password [(ngModel)]="signupModel.password" [toggleMask]="true" class="psw-back-color"></p-password>
        </div>
        <div class="mt-1 p-1 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.75rem;color: #848790;font-weight: 500;">Confirm password</span>
            <p-password [(ngModel)]="signupModel.password_confirmation" [toggleMask]="true" class="psw-back-color"></p-password>
        </div>
        <div class="mt-2 p-1" style="text-align: center;">
            <button
                [disabled]="!signupModel.first_name || !signupModel.last_name || !signupModel.phone_number || !signupModel.email || !signupModel.password || !signupModel.password_confirmation"
                [style.background-color]="signupModel.first_name && signupModel.last_name && signupModel.phone_number && signupModel.email && signupModel.password && signupModel.password_confirmation ?  '#EF870A' : '#b4b4bb'"
                class="btn w-100 fm-prompt fw-bold btn-login"
                style="color: white;background-color: #EF870A;font-size: 1rem;border-radius: 12px;padding-top: 0.4rem;padding-bottom: 0.4rem;"
                (click)="signUp()">Sign up</button>
        </div>
        <div class="my-1 p-1 fm-rubik" style="text-align: center;">
            <span style="font-size: 0.8rem;font-weight: 400;color: #5D5D66;">
                You already have an account
            </span>
            <span class="fm-prompt" style="color: #EF870A;font-size: 0.9rem;font-weight: bold;cursor: pointer;"
                (click)="switchToLogin.emit()">Sign in</span>
        </div>
    </div>
</p-dialog>
